import { Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ApiService, SustainabilityMetricResponse } from '../../core/api.service';
import { I18nService } from '../../core/i18n.service';
import { PageSection } from '../page-section/page-section';

@Component({ selector: 'app-about', standalone: true, imports: [RouterLink, PageSection], templateUrl: './about.html', styleUrl: './about.scss' })
export class About implements OnInit {
  readonly sustainabilityMetric = signal<SustainabilityMetricResponse | null>(null);
  readonly isLoadingSustainability = signal(false);
  readonly sustainabilityLoadFailed = signal(false);

  constructor(public i18n: I18nService, private api: ApiService) {}

  ngOnInit(): void {
    void this.loadSustainabilityMetric();
  }

  async loadSustainabilityMetric(): Promise<void> {
    if (this.isLoadingSustainability()) return;
    this.isLoadingSustainability.set(true);
    this.sustainabilityLoadFailed.set(false);
    try {
      this.sustainabilityMetric.set(await this.api.getSustainabilityMetric());
    } catch {
      this.sustainabilityLoadFailed.set(true);
      this.sustainabilityMetric.set(null);
    } finally {
      this.isLoadingSustainability.set(false);
    }
  }

  formatKg(value: number | null | undefined): string {
    if (typeof value !== 'number' || !Number.isFinite(value)) return this.i18n.t('about.sustainability.unavailableValue');
    return this.i18n.t('about.sustainability.kgCO2e', { value: new Intl.NumberFormat(this.i18n.dateLocale(), { maximumFractionDigits: 3 }).format(value) });
  }

  formatMetricDate(value: string | null | undefined): string {
    if (!value) return this.i18n.t('about.sustainability.unavailableValue');
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return this.i18n.t('about.sustainability.unavailableValue');
    return new Intl.DateTimeFormat(this.i18n.dateLocale(), { dateStyle: 'medium' }).format(date);
  }
}